module.exports = "/_next/static/images/8eb01dc81127baa1f9ef2996f49b53b1-roxinho-basicos-flutuantes-xs@1x.png.webp";